import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState, TCardId } from '../../../../../../../../types/types';
import { getUserChatId } from 'app/store/model/authUser/selectors/getIsUserChat';
import { getSortedComments } from 'app/view/react_components/base/components/Comments/selectors/getSortedComments';
import { chatLastCommentSeenUpdate } from '../../../../../../../../rest/effects/chats/chat/chatLastCommentSeenUpdate';

export const onResetUnseen = (
    cardId: TCardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        const chatId =  getUserChatId(getState(), cardId);
        if (!chatId) {
            return;
        }
        const comments = getSortedComments(getState(), cardId);
        dispatch(chatLastCommentSeenUpdate(chatId, comments.at(-1)));
    };
    return action;
};
